import { render } from "./Home.vue?vue&type=template&id=40d7234b&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=40d7234b&scoped=true&lang=css"

import exportComponent from "G:\\Storage\\VSCodeProjects\\MineMCPay\\minemcpay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d7234b"]])

export default __exports__